// extracted by mini-css-extract-plugin
module.exports = {"login-form":"mkE64","loginForm":"mkE64","loginFormContent":"_1s7hP","welcomeTexts":"tSLFA","welcomeDescription":"_1sFBj","googleSignInButton":"KZhZ4","poweredBy":"_2S344","wixMPLogo":"_24cOL","wixMpLogo":"_24cOL","googlePlatformLogo":"_6vT0S"};
    if(module.hot) {
      // 1568284650191
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  